angular.module('menu').controller('UserMenuController', [
    '$timeout',
    'AccountManager',
    'Event',
    function($timeout, AccountManager, Event) {
        var vm = this;

        vm.initied = false;

        // User info

        vm.infoVisible = false;
        vm.toggleUserInfo = function() {
            vm.infoVisible = !vm.infoVisible;

            if (vm.infoVisible) {
                bindOnClickToClose();
            }
            else {
                unbindOnClickToClose();
            }
        };

        vm.closeUserInfo = function() {
            vm.infoVisible = false;
            unbindOnClickToClose();
        };

        vm.binded = false;
        function onclickListener(event) {
            var userInfoElement = angular.element(document.getElementById('user-info'));
            var clickedElement = angular.element(event.target);

            if (userInfoElement && userInfoElement[0]) {
                if (!isDescendant(userInfoElement[0], clickedElement[0])) {
                    vm.closeUserInfo();
                }
            }
        }
        function isDescendant(parent, child) {
            var node = child.parentNode;
            while (node != null) {
                if (node == parent) {
                    return true;
                }
                node = node.parentNode;
            }

            return false;
        }
        function bindOnClickToClose() {
            $timeout(function() {
                if (!vm.binded) {
                    document.body.addEventListener('click', onclickListener);
                    vm.binded = true;
                }
            });
        }
        function unbindOnClickToClose() {
            $timeout(function() {
                if (vm.binded) {
                    document.body.removeEventListener('click', onclickListener, false);
                    vm.binded = false;
                }
            });
        }

        // Init

        function reloadUserData(ctrl) {
            ctrl.loggedUser = AccountManager.getLoggedUser();
            ctrl.initied = true;

            // Nombre del usuario
            ctrl.userName = ctrl.loggedUser && ctrl.loggedUser.id
                ? ctrl.loggedUser.name + ' ' + ctrl.loggedUser.lastname
                : '';
        }

        vm.$onInit = function() {
            return AccountManager.init()
                .then(function() {
                    reloadUserData(vm);
                });
        };
        Event.on('login', function() {
            reloadUserData(vm);
        });
        Event.on('logout', function() {
            reloadUserData(vm);
        });
    }]);
